module.exports = __webpack_public_path__ + "img/19.be3d3ac9.jpg";